import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment, UrlTree, Router } from '@angular/router';
import { LocalStorageService } from '@services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class IsAuthenticatedGuard implements CanMatch {

  constructor(
    private readonly _storage: LocalStorageService,
    private readonly _router: Router
  ) {}

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree {
    const token: string = this._storage.get('token');

    if (!token || !this._isTwofaVerified(token)) {
      return this._router.createUrlTree(['/login']);
    }

    return true;
  }

  private _isTwofaVerified(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload?.['2fa_verified'] === true;
    } catch {
      return false;
    }
  }
}
